import type { Task } from '@/types/task';

export const ORIGIN_LABELS: Record<string, string> = {
  delivery: 'Entregas',
  sale: 'Vendas',
  loan: 'Empréstimos',
  rental: 'Locações',
  rental_collection: 'Coleta de Locação',
  crm: 'CRM',
  manual: 'Manual',
  other: 'Outro',
};

export const ORIGIN_ROUTES: Record<string, (id: string) => string> = {
  delivery: (id) => `/dashboard/logistics?delivery=${id}`,
  sale: (id) => `/dashboard/sales?sale=${id}`,
};

export const isSystemTask = (
  task: Pick<Task, 'is_system_generated' | 'origin_type' | 'delivery_id'> | null | undefined
): boolean => {
  if (!task) return false;
  // Fonte de verdade canônica: coluna is_system_generated do banco
  if (task.is_system_generated === true) return true;
  // Fallback para tipos de origem que são sempre gerados pelo sistema
  const SYSTEM_ORIGIN_TYPES = ['delivery', 'sale', 'loan', 'rental', 'rental_collection'];
  if (task.origin_type && SYSTEM_ORIGIN_TYPES.includes(task.origin_type)) return true;
  return false;
};

export const getOriginModule = (task: Pick<Task, 'origin_type'> | null | undefined): string => {
  if (!task?.origin_type) return 'Sistema';
  return ORIGIN_LABELS[task.origin_type] || 'Sistema';
};

export const getOriginRoute = (task: Pick<Task, 'origin_type' | 'origin_id' | 'delivery_id'> | null | undefined): string | null => {
  if (!task?.origin_type) return null;
  const id = task.origin_id || task.delivery_id;
  if (!id) return null;
  return ORIGIN_ROUTES[task.origin_type]?.(id) || null;
};
